import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ForceGraph3D from 'react-force-graph-3d';
import axios from 'axios';

const DreamMap = () => {
  const { mapId } = useParams();
  const [graphData, setGraphData] = useState({ nodes: [], links: [] });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://api.mmai.live/api/graphdata/${mapId}`); // Replace with your API endpoint
        setGraphData(response.data);
      } catch (error) {
        console.error('Error fetching graph data:', error);
      }
    };

    fetchData();
  }, [mapId]);

  return (
    <ForceGraph3D
      graphData={graphData}
      backgroundColor='#f0f0f0'
    />
  );
};

export default DreamMap;